import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
  const { colors: { inputs: { dateTimePicker } }, spacing } = theme;
  return createStyles({
    calendar: {
      ...theme.typography.textSmallCompact,
      '&.datepickerStyles': {
        boxShadow: theme.shadow.dropShadow200,
        borderRadius: theme.borders.radius1,
        border: 'none',
        marginTop: spacing(0.5),

        '& .react-datepicker__week': {
        },

        '& .react-datepicker__day': {
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: spacing(6),
          width: spacing(6),
          boxSizing: 'border-box',
          borderRadius: `${dateTimePicker.dayCell.corner}px`,
          color: dateTimePicker.dayCell.enabled.text,
          outline: 'none',

          '&:hover': {
            color: dateTimePicker.dayCell.hovered.text,
            backgroundColor: dateTimePicker.dayCell.hovered.fill,
          },

          '&--disabled': {
            color: dateTimePicker.dayCell.disabled.text,
          },
        },
        '& .react-datepicker__day--selected': {
          backgroundColor: dateTimePicker.dayCell.selected.fill,
          color: dateTimePicker.dayCell.selected.text,
        },
        '& .react-datepicker__day--keyboard-selected': {
          backgroundColor: 'unset',
        },
        '& .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--today)': {
        },
        '& .react-datepicker__day--keyboard-selected.react-datepicker__day--today': {

        },
        '& .react-datepicker__day--today': {
          border: `2px solid ${dateTimePicker.dayCell.enabled.todayStroke}`,
        },
        '& .react-datepicker__day-name': {
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: spacing(6),
          width: spacing(6),
          boxSizing: 'border-box',
        },
        '& .react-datepicker__day-names': {
          paddingBottom: 0,
        },
        '& .react-datepicker__day--outside-month': {
          color: dateTimePicker.dayCell.disabled.text,
        },
        '& .react-datepicker__triangle': {
          display: 'none',
        },
        '& .react-datepicker__header': {
          background: 'none',
          borderBottom: 'none',
          padding: 0,
        },
        '& .react-datepicker__month': {
          margin: 0,
        },
        '& .react-datepicker__navigation': {
          height: spacing(5),
          width: spacing(5),

          '&:hover .react-datepicker__navigation-icon:before': {
          },
        },
        '& .react-datepicker__navigation-icon': {
          left: 0,
          right: 0,

          '&:before': {
          },
        },
        '& .react-datepicker__navigation--previous': {
          left: spacing(1),
        },
        '& .react-datepicker__navigation--next': {
          right: spacing(1),
        },
        '& .react-datepicker__current-month': {
          paddingTop: spacing(1),
          paddingBottom: spacing(1),
          fontWeight: 'normal',
          textTransform: 'capitalize',
        },
        '& .react-datepicker-time__caption': {
          display: 'none',
        },
        '& .react-datepicker__input-time-container': {
          margin: 0,
          marginTop: spacing(1),
        },
        '& .react-datepicker-time__input-container': {
          display: 'block',
          paddingRight: spacing(1),
        },
        '& .react-datepicker-time__input-container .react-datepicker-time__input': {
          display: 'block',
        },
      },
    },
    hidden: {
      visibility: 'hidden',
    },
  });
};

export default styles;
